import { withContextFactory } from "../contexts.utils";
import { AuthContext, IAuthContext } from "./AuthContext";

export interface WithAuthContext {
    authContext: IAuthContext
}

export const withAuthContext = withContextFactory<WithAuthContext>(AuthContext, "authContext");